import React, { useRef, useEffect, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./AgentDetailsComp.scss";
import arrowIcon from "../../../assets/Icons/map-tooltip-arrow.svg";
const AgentMapWithPopup = ({ data, data2, isSingle = false }) => {
  const mapRef = useRef(null);
  const [routePoints, setRoutePoints] = useState([]);
  const [singlePoint, setSinglePoint] = useState([]);
  const { feedback_details, case_details } = data2?.data || {};

  useEffect(() => {
    setRoutePoints(
      data?.data?.location_data?.map((item) => [
        Number(item.latitude),
        Number(item.longitude),
      ]) || [],
    );
  }, [data]);

  useEffect(() => {
    let lat = Number(data2?.data?.feedback_details?.lat);
    let lng = Number(data2?.data?.feedback_details?.long);
    // Fallback to default if invalid
    if (isNaN(lat) || isNaN(lng)) {
      lat = 23.5337;
      lng = 87.3218;
    }
    setSinglePoint(data2?.data?.feedback_details ? [lat, lng] : []);
  }, [data2]);

  console.log(singlePoint, "data2data2data2");

  useEffect(() => {
    if (mapRef.current && !mapRef.current._leaflet_id) {
      const map = L.map(mapRef.current).setView(
        routePoints.length > 0 ? routePoints[0] : [20.5937, 78.9629], // fallback India center
        15,
      );

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
      }).addTo(map);

      //        L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", {
      // attribution:
      //   '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
      // subdomains: "abcd",
      // maxZoom: 20,

      if (!isSingle) {
        // Draw route line + polygon
        L.polyline(routePoints, {
          color: "#F2654A",
          weight: 3,
          opacity: 0.7,
        }).addTo(map);
        L.polygon(routePoints, {
          color: "#F2654A",
          fillColor: "#F2654A",
          fillOpacity: 0.2,
        }).addTo(map);

        // Add markers dynamically
        data?.data?.location_data?.forEach((point) => {
          if (!point.latitude || !point.longitude) return;

          const hasContent = point.evidence || point.summary;

          // Define popup content only if needed
          const popupContent = hasContent
            ? `
  <div style="min-width:260px; max-width:320px; background:#fff; border-radius:12px; display:flex; flex-direction:column; gap:2px;">

    <!-- Header -->
    <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:6px;">
      <span class="map-tooltip-grey-text">Report Summary</span>
      <span class="map-tooltip-grey-text" >Evidence</span>
    </div>

    <!-- Content -->
    <div style="display:flex; align-items:flex-start; gap:12px;">
      <!-- Summary -->
      <div class="map-tooltip-summary">
        ${point?.summary || "<em style='color:#888; font-size:12px;'>No summary</em>"}
      </div>

      <!-- Evidence -->
      <div style="display:flex; ; align-items:start; gap:10px;">
        ${
          point?.evidence
            ? `<div class="map-tooltip-evidence-container">
            <img src='${point.evidence}' alt='evidence' class="map-tooltip-evidence-img"
                 />
            </div>`
            : "<em style='color:#888; font-size:12px;'>No evidence</em>"
        }
        ${
          point?.evidence
            ? `<div class="map-tooltip-arrow-container">
        <img src='${arrowIcon}' alt='arrow' style='width:16px; height:16px; margin-top:4px;' />
        </div>`
            : ""
        }
      </div>
    </div>
  </div>
`
            : null;

          const marker = L.circleMarker(
            [Number(point.latitude), Number(point.longitude)],
            {
              radius: hasContent ? 6 : 3, // Smaller radius if no content
              color: hasContent ? "#F2654A" : "#fff", // Orange border if content, White if not
              fillColor: hasContent ? "#fff" : "#F2654A", // White fill if content, Orange if not
              fillOpacity: 1,
              weight: 1,
            },
          ).addTo(map);

          if (hasContent && popupContent) {
            marker.bindPopup(popupContent, { closeButton: false });

            marker.on("mouseover", function () {
              this.openPopup();
            });
            marker.on("mouseout", function () {
              this.closePopup();
            });
          }
        });
      } else if (isSingle) {
        // Single: show a marker at the dummy location, draw a dotted circle, and focus map on it
        // Fallback to default if singlePoint is empty or invalid
        const validPoint =
          Array.isArray(singlePoint) &&
          singlePoint.length === 2 &&
          !isNaN(singlePoint[0]) &&
          !isNaN(singlePoint[1])
            ? singlePoint
            : [23.5337, 87.3218];
        map.setView(validPoint, 17, { animate: true });
        // Draw dotted circle
        L.circle(validPoint, {
          radius: 120, // meters
          color: "#F2654A",
          weight: 2,
          fill: true,
          fillColor: "#F2654A",
          fillOpacity: 0.08,
          dashArray: "6 6",
        }).addTo(map);
        // Draw marker
        L.circleMarker(validPoint, {
          radius: 8,
          color: "#4285F4",
          fillColor: "#fff",
          fillOpacity: 1,
          weight: 3,
        }).addTo(map);
      }
    }
  }, [routePoints, data]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: 320,
        borderRadius: 12,
        overflow: "hidden",
        margin: "16px 0",
        zIndex: 0,
      }}
    >
      <div
        ref={mapRef}
        key={JSON.stringify(isSingle ? singlePoint : routePoints)}
        style={{
          width: "100%",
          height: 320,
          borderRadius: 12,
          overflow: "hidden",
        }}
      />
      {isSingle && (
        <img
          src={feedback_details?.image}
          alt="evidence"
          style={{
            position: "absolute",
            right: 5,
            bottom: 5,
            width: 180,
            height: 120,
            objectFit: "cover",
            borderRadius: 10,
            border: "2px solid #fff",
            boxShadow: "0 2px 12px rgba(0,0,0,0.12)",
            background: "#fff",
            zIndex: 199999,
          }}
        />
      )}
    </div>
  );
};

export default AgentMapWithPopup;
